import '../../stylesheets/smart_phone/catalog_list.css'
